import { Tab } from '@mui/material';
import { createLink } from '@tanstack/react-router';

export const TabLink = createLink(Tab);
